<template>
<div>
    <div v-if="enabled" class="donotprint">
        <button @click="toggleShowAnnotatorList"
            v-if="! showAnnotatorList"
            class="annotator-toggle cursor-pointer fixed right-0 top-0 block lg:hidden text-white z-20 bg-gray-900 hover:bg-gray-900 rounded-l-lg text-4xl mt-1 mr-1 p-0 w-8 h-8 flex justify-center items-center"
            aria-label="Show entries list"
            ref="toggleButton"
        >
            <i aria-hidden="true" class="material-icons text-2xl">view_list</i>

            <div class="fixed top-0 right-0 h-screen block w-2 bg-gray-900"></div>
        </button>
    </div>

    <div v-if="enabled"
        class="donotprint fixed top-0 right-0 h-screen w-5/6 md:w-1/2 lg:w-1/6 z-40 xl:w-1/6 xxl:w-3/12 bg-gray-900 p-3 overflow-y-auto overflow-x-visible"
        :class="showAnnotatorList ? 'block' : 'hidden lg:block'"
    >
        <button @click="toggleShowAnnotatorList"
            v-if="showAnnotatorList"
            class="flex justify-center items-center cursor-pointer w-8 h-8 fixed top-0 lg:hidden text-red-100 z-50 bg-gray-900 hover:bg-gray-900 rounded-l-lg -ml-10 mt-1"
            aria-label="Hide entries list"
            ref="toggleButton"
        >
            <i aria-hidden="true" class="material-icons text-2xl">cancel</i>
        </button>

        <div v-if="self" class="-ml-3 -mt-2 mb-2">
            <a :href="'/users/' + self_id + '/reportsections/' + section_id" class="no-underline font-bold text-blue-700 cursor-pointer text-sm inline-block bg-yellow-300 hover:bg-yellow-400 hover:text-blue-800 rounded-r px-3 py-1">
                Polish This
                <i class="pr-0 mx-auto w-4 inline-block fill-current align-middle">
                    <svg width="100%" viewBox="0 0 22 23" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" xmlns:serif="http://www.serif.com/" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;">
                      <g transform="matrix(1,0,0,1,-434.252,-521.095)">
                          <g transform="matrix(0.0871887,0,0,0.0871887,399.459,502.494)">
                              <g transform="matrix(0.449558,0.449558,0.270258,-0.270258,-298.625,-168.563)">
                                  <path d="M1422.26,328.605L1522.19,328.605L1522.19,316.978C1504.66,304.202 1490.73,275.924 1491.82,229.56L1451.98,229.56C1452.41,281.808 1436.52,303.916 1422.26,316.547L1422.26,328.605Z"/>
                              </g>
                              <g transform="matrix(1,0,0,1,120.249,0)">
                                  <path d="M418.747,267.176C360.751,319.912 360.456,316.809 308.104,374.094C325.645,391.96 343.184,409.828 360.72,427.69C419.006,373.532 416.431,374.578 468.765,317.195L418.747,267.176Z"/>
                              </g>
                              <g transform="matrix(1,0,0,1,63.3984,56.6458)">
                                  <path d="M538.083,161.068L499.664,199.48C496.191,202.952 496.192,208.634 499.662,212.105L523.826,236.268C527.301,239.743 532.979,239.739 536.451,236.267L574.871,197.856L579.344,202.329C551.381,234.266 560.234,230.166 531.941,261.542L474.951,204.552C506.431,176.263 522.047,168.374 533.718,156.703L538.083,161.068Z"/>
                              </g>
                              <g transform="matrix(0.392865,0.392865,0.435849,-0.435849,-318.106,17.5785)">
                                  <path d="M1430.93,833.974L1512.76,833.974L1512.77,743.323C1512.77,735.599 1506.46,729.28 1498.73,729.28L1444.98,729.28C1437.26,729.28 1430.94,735.599 1430.94,743.323L1430.93,833.974Z"/>
                              </g>
                              <g transform="matrix(1,0,0,1,-2.70938,8.5443)">
                                  <path d="M634.879,442.415C537.127,435.952 403.22,442.415 403.22,442.415C403.22,442.415 399.955,457.634 403.22,457.474C524.03,451.578 634.879,457.474 634.879,457.474C634.879,457.474 639.888,442.746 634.879,442.415Z"/>
                              </g>
                              <g transform="matrix(1,0,0,1,313.022,-83.4921)">
                                  <path d="M89.312,525.867C93.416,525.685 101.817,525.329 113.357,524.933L115.583,522.707L103.984,511.108L89.312,525.867Z"/>
                              </g>
                          </g>
                      </g>
                    </svg>
                </i>
            </a>
        </div>

        <section v-if="annotations.length" aria-labelledby="entries-panel-heading">
            <h2 id="entries-panel-heading" class="text-white font-semibold text-sm px-2 py-0 mb-3">
                Entries <span v-if="section_name">on</span> <br>{{ section_name }}
            </h2>

            <div v-if="has_archived" class="flex items-center py-4 px-2">
                <toggle-button
                    @change="toggleShowArchived"
                    :value="showArchived"
                    :sync="true"
                    :color="{checked: '#7f9cf5', unchecked: '#6e6d7e'}"
                    :switch-color="{checked: '#ffffff', unchecked: '#a9a8c2'}"
                    :width="26"
                    :height="15"
                    :margin="1"
                    :speed="100"
                />

                <div class="text-indigo-400 font-sm cursor-pointer text-xs hover:text-indigo-200 select-none text-xxs pl-2"
                    @click="toggleShowArchived"
                >
                    Show Archived
                </div>
            </div>

            <annotation-list-item
                v-for="annotation in valid_annotations"
                class="rounded mb-8"
                :key="annotation.id"
                :annotation="annotation"
                :self_id="self_id"
                :read_only="read_only"
                @updateComments="$emit('updateComments', $event)"
                @deleteAnnotation="$emit('deleteAnnotation', $event)"
            />
        </section>
    </div>
</div>
</template>

<script>
import AnnotationListItem from './annotation-list-item.vue';
import { ToggleButton } from 'vue-js-toggle-button'

export default {
    components: {
        AnnotationListItem,
        ToggleButton,
    },

    props: {
        annotations: { type: Array, default: () => []},
        section_name: null,
        enabled: true,
        self_id: null,
        self:'',
        section_id:'',
        read_only: { type: Boolean, default: false },
    },

    data() {
        return {
            showArchived: false,
            showAnnotatorList: this.getInitialShowAnnotatorList(),
        }
    },

    computed: {
        valid_annotations() {
            return this.showArchived
                ? this.annotations
                : this.annotations.filter(annotation => annotation.original_has_changed != true);
        },
        has_archived() {
            return this.annotations.some(annotation => annotation.original_has_changed == true);
        },
    },

    methods: {
        toggleShowArchived() {
            this.showArchived = ! this.showArchived;
        },
        toggleShowAnnotatorList() {
            this.showAnnotatorList = ! this.showAnnotatorList;
            this.$nextTick(() => {
                this.$refs.toggleButton?.focus();
            });
        },
        getInitialShowAnnotatorList() {
            return window.innerWidth > 1024;
        },
    },
}
</script>
